module.exports = __webpack_public_path__ + "static/media/arrow-left.5fd78ce9.svg";